import React, { useEffect, useRef, useState } from "react";

const DURATION_MS = 24 * 60 * 60 * 1000; // 24 horas
const STORAGE_KEY = "arca_offer_deadline";

// Devuelve el deadline; si no existe o ya venció, crea uno nuevo (evergreen)
const getDeadline = () => {
  const now = Date.now();
  try {
    const stored = Number(localStorage.getItem(STORAGE_KEY));
    if (stored && stored > now) return stored;
    const fresh = now + DURATION_MS;
    localStorage.setItem(STORAGE_KEY, String(fresh));
    return fresh;
  } catch (e) {
    return now + DURATION_MS;
  }
};

const pad = (n) => String(n).padStart(2, "0");

const Unit = ({ value, label }) => (
  <div className="flex flex-col items-center">
    <span
      data-testid={`countdown-${label.toLowerCase()}`}
      className="flex h-14 w-14 items-center justify-center rounded-xl bg-[hsl(var(--brand-ink))] font-heading text-2xl font-extrabold tabular-nums text-white shadow-[0_6px_16px_rgba(31,41,55,0.18)] sm:h-16 sm:w-16 sm:text-3xl"
    >
      {pad(value)}
    </span>
    <span className="mt-1.5 text-[10px] font-bold uppercase tracking-wide text-muted-foreground sm:text-xs">
      {label}
    </span>
  </div>
);

export const Countdown = ({ className = "" }) => {
  const deadlineRef = useRef(getDeadline());
  const [remaining, setRemaining] = useState(deadlineRef.current - Date.now());

  useEffect(() => {
    const tick = () => {
      let diff = deadlineRef.current - Date.now();
      if (diff <= 0) {
        // Reinicia el temporizador para mantener la urgencia siempre activa
        try {
          localStorage.removeItem(STORAGE_KEY);
        } catch (e) {}
        deadlineRef.current = getDeadline();
        diff = deadlineRef.current - Date.now();
      }
      setRemaining(diff);
    };

    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []);

  const totalSeconds = Math.max(0, Math.floor(remaining / 1000));
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return (
    <div
      data-testid="offer-countdown"
      className={`flex items-center justify-center gap-2.5 sm:gap-3 ${className}`}
    >
      <Unit value={hours} label="Horas" />
      <span className="pb-5 font-heading text-2xl font-extrabold text-[hsl(var(--brand-ink))]/40">:</span>
      <Unit value={minutes} label="Min" />
      <span className="pb-5 font-heading text-2xl font-extrabold text-[hsl(var(--brand-ink))]/40">:</span>
      <Unit value={seconds} label="Seg" />
    </div>
  );
};
